import Image from "next/image"

import { cn } from "@/lib/utils"

export function CorrectFlagIcon({
  country,
  className,
}: {
  country: string
  className?: string
}) {
  return (
    <Image
      className={cn("rounded-full border", className || "")}
      src={`/tsp/flags/${country}.svg`}
      width={32}
      height={32}
      alt={`${country}`}
    />
  )
}
